import * as React from "react";
import type { SVGProps } from "react";

const SvgClockLight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={20}
    fill="none"
    viewBox="0 0 21 20"
    {...props}
  >
    <g clipPath="url(#clock-light_svg__a)">
      <path
        fill="#000"
        d="M18.863 10a8.75 8.75 0 1 1-17.5 0 8.75 8.75 0 0 1 17.5 0M.113 10a10 10 0 1 0 20 0 10 10 0 0 0-20 0m9.375-5.625V10c0 .207.106.402.278.52l3.75 2.5c.289.19.675.113.867-.172a.627.627 0 0 0-.172-.868l-3.473-2.316V4.375a.627.627 0 0 0-.625-.625.627.627 0 0 0-.625.625"
      />
    </g>
    <defs>
      <clipPath id="clock-light_svg__a">
        <path fill="#fff" d="M.113 0h20v20h-20z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgClockLight;
